import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/u/[id]/FollowWidget.tsx");
